import { permissionsSelector } from "../../../Login/selectors/permissionSelector";
import { useRecoilValue } from "recoil";
import { PERMISSIONS } from "../../../PermissionsConstants";
import EmployeesTable from "./views/EmployeesTable";
import { accountAtom } from "modules/Login/atoms/AccountAtom";

const Employees = () => {
  const userAccount = useRecoilValue(accountAtom);
  const userPermissions = useRecoilValue(permissionsSelector);

  const hasUSView = userPermissions.includes(
    PERMISSIONS.permission_carrieragreemnentmgmt_employee_view
  );
  const hasMXView = userPermissions.includes(
    PERMISSIONS.permission_employee_mexicoemployee_view
  );

  const isUSUser = userAccount.isFranchise || userAccount.isNonFranchise;
  const isMexicoUser = userAccount.isMexico;

  const viewPermission =
    (isUSUser && hasUSView) ||
    (isMexicoUser && hasMXView) ||
    (isUSUser && isMexicoUser && (hasUSView || hasMXView));

  return <>{viewPermission ? <EmployeesTable /> : ""}</>;
};

export default Employees;
